import { Skeleton } from "@mui/material";
import { styled } from "@mui/material/styles";

import { CSSVariable } from "../utils/CSSVariable";

const HEIGHT_SMALL_SCREEN_VARIABLE = new CSSVariable("--hero-image-small-screen-height");
const HEIGHT_MEDIUM_SCREEN_VARIABLE = new CSSVariable("--hero-image-medium-screen-height");

const HeroSectionContainer = styled("div")(({ theme }) => ({
    height: HEIGHT_SMALL_SCREEN_VARIABLE.reference,
    [theme.breakpoints.up("md")]: {
        height: HEIGHT_MEDIUM_SCREEN_VARIABLE.reference,
    },
}));

const DEFAULT_MEDIUM_SCREEN_HEIGHT = 300;
const DEFAULT_SMALL_SCREEN_HEIGHT = 200;

export function HeroImageSkeleton({
    smallScreenHeight = DEFAULT_SMALL_SCREEN_HEIGHT,
    mediumScreenHeight = DEFAULT_MEDIUM_SCREEN_HEIGHT,
}: {
    smallScreenHeight?: number;
    mediumScreenHeight?: number;
}) {
    const finalStyle = {
        [HEIGHT_SMALL_SCREEN_VARIABLE.toString()]: smallScreenHeight + "px",
        [HEIGHT_MEDIUM_SCREEN_VARIABLE.toString()]: mediumScreenHeight + "px",
    };
    return (
        <HeroSectionContainer style={finalStyle}>
            <Skeleton variant="rectangular" height={"100%"} width={"100%"} />
        </HeroSectionContainer>
    );
}
